export const Package = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.825 10C8.28063 10 8.65 10.3694 8.65 10.825V11.625C8.65 12.4671 8.98451 13.2746 9.57994 13.8701C10.1754 14.4655 10.9829 14.8 11.825 14.8C12.6671 14.8 13.4746 14.4655 14.0701 13.8701C14.6655 13.2746 15 12.4671 15 11.625V10.825C15 10.3694 15.3694 10 15.825 10C16.2806 10 16.65 10.3694 16.65 10.825V11.625C16.65 12.9047 16.1417 14.1319 15.2368 15.0368C14.3319 15.9417 13.1047 16.45 11.825 16.45C10.5453 16.45 9.31807 15.9417 8.41321 15.0368C7.50835 14.1319 7 12.9047 7 11.625V10.825C7 10.3694 7.36937 10 7.825 10Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.825 8.45C8.28063 8.45 8.65 8.08064 8.65 7.625V6.825C8.65 5.98294 8.98451 5.17536 9.57994 4.57994C10.1754 3.98451 10.9829 3.65 11.825 3.65C12.6671 3.65 13.4746 3.98451 14.0701 4.57994C14.6655 5.17536 15 5.98294 15 6.825V7.625C15 8.08064 15.3694 8.45 15.825 8.45C16.2806 8.45 16.65 8.08064 16.65 7.625V6.825C16.65 5.54533 16.1417 4.31807 15.2368 3.41321C14.3319 2.50835 13.1047 2 11.825 2C10.5453 2 9.31807 2.50835 8.41321 3.41321C7.50835 4.31807 7 5.54533 7 6.825V7.625C7 8.08064 7.36937 8.45 7.825 8.45Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3 9.65C3 8.07599 4.07452 6.8 5.4 6.8H18.2C19.5255 6.8 20.6 8.07599 20.6 9.65V19.15C20.6 20.724 19.5255 22 18.2 22H5.4C4.07452 22 3 20.724 3 19.15V9.65ZM5.4 8.7H18.2C18.6418 8.7 19 9.12533 19 9.65V19.15C19 19.6747 18.6418 20.1 18.2 20.1H5.4C4.95817 20.1 4.6 19.6747 4.6 19.15V9.65C4.6 9.12533 4.95817 8.7 5.4 8.7Z"
			fill="currentColor"
		/>
	</svg>
);
